module.exports = __webpack_public_path__ + "img/pgw.2ad1aeb5.jpg";